export default {
  navigationBarTitleText: '身份核验',
};
